import React from "react";

const ViewportSlot: React.FC = ({ children }) => <>{children}</>;

export default ViewportSlot;
